import React from 'react'
import { withStyles, /*Typography,*/ Hidden } from '@material-ui/core'
import { ArcGauge } from '@progress/kendo-react-gauges'
import classNames from 'classnames'
import Paper from 'components/theme/Paper'

const styles = (theme) => ({
  arcGauge: {
    height: 75,
  },
  arcGaugeLabel: {
    [theme.breakpoints.up('xs')]: {
      fontSize: theme.typography.pxToRem(9),
      fontWeight: 'bold',
      marginTop: '-28px',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 'normal',
      marginTop: '-27px',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '-15px',
      fontSize: theme.typography.pxToRem(14),
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '-10px',
      fontSize: theme.typography.pxToRem(17),
    },
  },
  arcGaugeLabelHalf: {
    [theme.breakpoints.up('xs')]: {
      fontSize: theme.typography.pxToRem(9),
      fontWeight: 'bold',
      marginTop: '-30px',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 'normal',
      marginTop: '-27px',
    },
  },
  dataPanel: {
    textAlign: 'center',
    color: '#fff',
    [theme.breakpoints.up('xs')]: {
      height: 70,
      padding: '5px',
    },
    [theme.breakpoints.up('sm')]: {
      height: 83,
      padding: '8px',
    },
    [theme.breakpoints.up('md')]: {
      height: 152,
      padding: theme.spacing.unit * 2,
    },
  },
  dataPanelHalf: {
    textAlign: 'center',
    color: '#fff',
    [theme.breakpoints.up('xs')]: {
      height: 70,
      padding: '5px',
    },
    [theme.breakpoints.up('lg')]: {
      height: 83,
      padding: '8px',
    },
  },
  green: {
    backgroundColor: theme.palette.green,
  },
  orange: {
    backgroundColor: theme.palette.orange,
  },
  pink: {
    backgroundColor: theme.palette.pink,
  },
  purple: {
    backgroundColor: theme.palette.primary.main,
  },
  blue: {
    backgroundColor: theme.palette.secondary.main,
  },
  red: {
    backgroundColor: theme.palette.red,
  },
  text: {
    color: '#fff',
    [theme.breakpoints.up('xs')]: {
      fontSize: '14px',
      width: '101px',
      margin: 0,
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '16px',
      width: '101px',
      margin: 0,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(20),
      marginTop: 30,
      // marginLeft: 5,
      fontWeight: 'bold',
    },
    // [theme.breakpoints.up('lg')]: {
    //   fontSize: theme.typography.pxToRem(23),
    // },
  },
  textHalf: {
    color: '#fff',
    [theme.breakpoints.up('xs')]: {
      fontSize: '14px',
      width: '101px',
      margin: 0,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '16px',
      width: '101px',
      margin: 0,
    },
  },
  longPercent: {
    [theme.breakpoints.up('xs')]: {
      fontSize: theme.typography.pxToRem(16),
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(28),
      margin: '0 0 10px',
      fontWeight: 'bold',
    },
    [theme.breakpoints.up('md')]: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: theme.typography.pxToRem(44),
    },
  },
  longPercentHalf: {
    [theme.breakpoints.up('xs')]: {
      fontSize: theme.typography.pxToRem(16),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.typography.pxToRem(28),
      margin: '0 0 10px',
      fontWeight: 'bold',
    },
  },
  mainHeading: {
    margin: '15px 0 -10px',
    [theme.breakpoints.up('xs')]: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 'bold',
      margin: '0 0 8px',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(28),
      margin: '-5px 0 0 4px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(55),
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      marginTop: 11,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.typography.pxToRem(55),
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      marginTop: 0,
    },
  },
  mainHeadingHalf: {
    margin: '15px 0 -10px',
    [theme.breakpoints.up('xs')]: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 'bold',
      margin: '0 0 8px',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.typography.pxToRem(28),
      margin: '0 0 4px',
    },
  },
  heading: {
    [theme.breakpoints.up('xs')]: {
      fontSize: theme.typography.pxToRem(9),
      fontWeight: 'bold',
      marginBottom: 0,
      marginTop: '-3px',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 'normal',
      marginTop: '2px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(16),
      marginTop: 10,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.typography.pxToRem(22),
      marginTop: 6,
    },
  },
  headingHalf: {
    [theme.breakpoints.up('xs')]: {
      fontSize: theme.typography.pxToRem(9),
      fontWeight: 'bold',
      marginBottom: 0,
      marginTop: '-6px',
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 'normal',
    },
  },
})

export default withStyles(styles)(
  ({ classes, color, arcGauge, value, property, label, half, fontSize }) => {
    const Half = half ? 'Half' : ''

    const mainHeading = (
      <>
        <Hidden smDown>
          <div
            style={fontSize && !half ? { fontSize } : null}
            className={
              value && value < 100
                ? classes[`mainHeading${Half}`]
                : classes[`longPercent${Half}`]
            }
          >
            {value || value === 0 ? `${value}%` : '--%'}
          </div>
        </Hidden>
        <Hidden mdUp>
          <div
            className={
              value && value < 100
                ? classes[`mainHeading${Half}`]
                : classes[`longPercent${Half}`]
            }
          >
            {value || value === 0 ? `${value}%` : '--%'}
          </div>
        </Hidden>
      </>
    )

    return (
      <Paper
        className={classNames(classes[`dataPanel${Half}`], classes[color])}
      >
        {arcGauge ? (
          <div style={{ width: '100%', height: '85%' }}>
            {half ? null : (
              <Hidden smDown>
                <ArcGauge
                  color={'#fff'}
                  style={{
                    height: '100%',
                    width: '100%',
                    marginTop: '-10px',
                    color: 'transparent',
                  }}
                  value={value ? value : 0}
                  arcCenterRender={() => (
                    <div className={classes[`text${Half}`]}>
                      {`${value || value === 0 ? value : '--'}% ${property}`}
                    </div>
                  )}
                />
              </Hidden>
            )}
            {half ? mainHeading : <Hidden mdUp>{mainHeading}</Hidden>}
          </div>
        ) : null}
        {arcGauge ? (
          <div className={classes[`arcGaugeLabel${Half}`]}>{label}</div>
        ) : null}
        {arcGauge ? null : (
          <div className={classes[`mainHeading${Half}`]}>
            {value || value === 0 ? value : '--'}
          </div>
        )}
        {arcGauge ? null : (
          <div className={classes[`heading${Half}`]}>{label}</div>
        )}
      </Paper>
    )
  },
)
